import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackChangedVideoClosedCaptionTrack.meta';

export type TrackChangedVideoClosedCaptionTrackParams = {
  id: string;
  track: string;
};

export const useTrackChangedVideoClosedCaptionTrack = () => {
  const { track } = useAnalyticsUtilities();

  const trackChangedVideoClosedCaptionTrack = useCallback(
    (params: TrackChangedVideoClosedCaptionTrackParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackChangedVideoClosedCaptionTrack };
};
